import React from 'react';
import { Workspace } from '../../../interfaces/workspaces';
import { Truncate } from '../../../helpers/Text';
import { BuildPath } from '../../../helpers/Paths';
import { GlobalSettings } from '../../../global/GlobalSettings';

const WorkspaceItem = (props: {item:Workspace, count:boolean, showmodel:boolean, titleLength:number}) => {    
    
    let { item, count, titleLength } = props;

    const plural = (count:number) => {
        if (count !== 1){
            return (
                "s"
            )
        }
        return "";
    }

    const icon = (icon:string) => {
        if (icon === ""){
            return `${BuildPath()}/${GlobalSettings.DefaultLogo}`
        }  
        return icon;
    }

    const onClick = () => {
        if(props.showmodel) {
            window.sessionStorage.setItem('showmodel', props.showmodel.toString())
        }
        window.location.href = `${item.url}`

    }
    // 36
    return (
        <li onClick={onClick}>
            <img alt={`${item.name} logo`} src={icon(item.icon)} />
            <a href={`${item.url}`} onClick={onClick}>{Truncate(item.name, titleLength)}</a>
            {count && <span>{item.userCount} User{plural(item.userCount)}, {item.groupCount} User Group{plural(item.groupCount)}</span>}
        </li>
    )
}

export { WorkspaceItem }